import React, { useContext } from "react";
import { Link } from "react-router-dom";
import CartContext from "../../cartcontext/CartContext";
import TimeContext from "../../timecontext/TimeContext";

function Cart(props) {
  const { toggleCart } = props;

  const { cartState, dispatchCart, getSum, getQty, countCart } = useContext(
    CartContext
  );

  const { isStoreClosed } = useContext(TimeContext);

  return (
    <div
      className="position-fixed shadow col-md-3 col-lg-3 col-12 py-4 animate__animated animate__slideInRight"
      style={{
        borderLeft: "solid 1px #ccc",
        zIndex: 1,
        top: 63,
        height: "100vh",
        right: 1,
        background: "#ffffff",
        overflow: "scroll",
      }}
    >
      <div className="px-3">
        <p className="font-weight-bold m-0">Your Order</p>
        {getSum() < 120 ? (
          <p className="text-muted-sm text-danger font-weight-bold">
            Minimum order is Rs 120.00
          </p>
        ) : (
          ""
        )}
        {!isStoreClosed() ? (
          <p className="text-muted-sm text-danger font-weight-bold">
            Store is closed. Please order between 10:00 am - 7:30 pm GMT+5:45
            time
          </p>
        ) : (
          ""
        )}
        <Link to="/order/checkout">
          <button
            className="btn btn-danger btn-sm  btn-block my-3"
            disabled={
              countCart() === 0 ||
              getSum() < 120 ||
              getQty() > 20 ||
              !isStoreClosed()
            }
            onClick={() => {
              toggleCart();
            }}
          >
            Checkout Rs. {getSum()}
          </button>
        </Link>
        {!Array.isArray(cartState) ||
          cartState.map((d, i) => (
            <div style={{ fontSize: "14px" }} key={d.guid}>
              <p className="m-0 d-flex justify-content-between">
                <span>
                  {d.qty} X {d.order.food}
                </span>
                <span style={{ width: "70px" }}>
                  Rs {d.qty * d.order.price}
                </span>
              </p>
              <span
                className="text-danger cursor-pointer"
                onClick={() => {
                  cartState.splice(i, 1);
                  dispatchCart({ type: "REMOVE", payload: cartState });
                }}
              >
                remove
              </span>
              <hr></hr>
            </div>
          ))}
      </div>
    </div>
  );
}

export default Cart;
